import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { LocaleContext } from '@/hooks/useTranslator';
import { Amount } from '@/types/amount';
import { Locale } from '@/types/locale';
import { transactionFromToAmount } from '@/utility/transactionFromToAmount';

interface Props {
  readonly from: Amount;
  readonly to: Amount;
}

export const AmountTransactionDetailsItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { from, to } = props;
  const locale = React.useContext<Locale>(LocaleContext);

  return (
    <Box>
      <Typography variant="body2">{transactionFromToAmount(locale, from, to)}</Typography>
    </Box>
  );
};
